import { useState } from "react";

export const Logo = ({ b, testid }) => (
  <a className="logo" href="#start" data-testid={testid}>{b.part1}<i>{b.part2}</i></a>
);

const NAV = [["#realizacje", "Realizacje"], ["#pakiety", "Pakiety"], ["#proces", "Jak działamy"], ["#dodatki", "Dodatki"], ["#faq", "FAQ"]];

export const Header = ({ c }) => (
  <header className="top" data-testid="site-header">
    <div className="wrap">
      <Logo b={c.brand} testid="header-logo" />
      <nav>
        {[...NAV.slice(0, 4), ...(c.testimonials?.enabled ? [["#opinie", "Opinie"]] : []), ...(c.calendar?.enabled ? [["#terminy", "Terminy"]] : []), NAV[4]].map(([h, t]) => <a key={h} href={h} data-testid={`nav-${h.slice(1)}`}>{t}</a>)}
        <a className="btn solid" href="#kontakt" data-testid="nav-cta-btn">{c.brand.nav_cta}</a>
      </nav>
    </div>
  </header>
);

export const Hero = ({ c }) => (
  <div className="hero" id="start" data-testid="hero-section">
    <div>
      <p className="label">{c.label}</p>
      <h1 data-testid="hero-title">{c.title} <em>{c.title_em}</em></h1>
      <p className="lead">{c.lead}</p>
      <div className="ctas">
        <a className="btn solid" href="#kontakt" data-testid="hero-cta-primary">{c.cta_primary}</a>
        <a className="btn line" href="#pakiety" data-testid="hero-cta-secondary">{c.cta_secondary}</a>
      </div>
      <div className="trust">
        {c.trust.map((t, i) => <div key={i}><b>{t.title}</b>{t.text}</div>)}
      </div>
    </div>
  </div>
);

export const Footer = ({ c }) => {
  const [terms, setTerms] = useState(false);
  const f = c.footer;
  return (
    <footer className="site" data-testid="site-footer">
      <div>
        <Logo b={c.brand} testid="footer-logo" />
        <p>{f.text}</p>
      </div>
      <div>
        <h4>Oferta</h4>
        <ul><li><a href="#pakiety">Pakiety</a></li><li><a href="#dodatki">Dodatki</a></li><li><a href="#wlasciciele">Dla właścicieli</a></li></ul>
      </div>
      <div>
        <h4>Informacje</h4>
        <ul>
          <li><a href="#faq">FAQ</a></li>
          <li><a href="#kontakt">Kontakt</a></li>
          <li><a href="#regulamin" data-testid="footer-terms-link" onClick={(e) => { e.preventDefault(); setTerms(true); }}>Regulamin</a></li>
        </ul>
      </div>
      <div className="legal"><span>{f.copyright}</span><span>{f.nip}</span></div>
      {terms && (
        <div className="lightbox" role="dialog" aria-modal="true" onClick={(e) => e.target === e.currentTarget && setTerms(false)} data-testid="terms-modal">
          <button className="close" type="button" onClick={() => setTerms(false)} aria-label="Zamknij" data-testid="terms-close-btn">×</button>
          <div className="terms-box"><p className="label">Regulamin</p><p className="terms-text">{f.terms}</p></div>
        </div>
      )}
    </footer>
  );
};
